import { CSSProperties } from "react";
import { RichText, RichTextKind } from "../../../../model/question/RichText";
import { DivHTMLText, HTMLTextDisplay } from "./DivHTMLText";
import { DivPureText, PureTextDisplay } from "./DivPureText";

interface DivRichTextProps {
    content: RichText;
    onSave?: (t: RichText) => void;
    style?: CSSProperties;
    saveRealTime?: boolean;
}

export function DivRichText(props: DivRichTextProps) {
    const { content, onSave, style, saveRealTime } = props;

    return (
        <>
            {content.type === RichTextKind.HTMLText ? (
                <DivHTMLText
                    text={content.html_text}
                    saveText={
                        onSave === undefined
                            ? undefined
                            : (t: string) => {
                                  onSave({ ...content, html_text: t });
                              }
                    }
                    style={style}
                    saveRealTime={saveRealTime}
                />
            ) : (
                <DivPureText
                    style={style}
                    text={content.pure_text}
                    onSave={
                        onSave === undefined
                            ? undefined
                            : (t: string) => {
                                  onSave({ ...content, pure_text: t });
                              }
                    }
                    onTransRich={onSave}
                    noSave={onSave === undefined}
                    containsRep={content.contains_rep}
                    saveRealTime={saveRealTime}
                />
            )}
        </>
    );
}

interface DivRichTextDisplayProps {
    content: RichText;
    style?: CSSProperties;
}
export function DivRichTextDisplay(props: DivRichTextDisplayProps) {
    const { content, style } = props;
    return (
        <>
            {content.type === RichTextKind.HTMLText ? (
                <HTMLTextDisplay text={content.html_text} style={style} />
            ) : (
                <PureTextDisplay text={content.pure_text} style={style} />
            )}
        </>
    );
}
